<template>
  <div>
    <div>
      <div class="panel-item">
        <el-form :model="discountForm" ref="discountForm">
          <el-form-item label="" style="margin-bottom: 0">
            <el-radio-group
              v-model="discountForm.discount_item_type"
              class="mt20"
              @change="radioState"
            >
              <el-radio-button
                class="mb20"
                v-for="type in discountItemTypesFood"
                :key="type.value"
                :label="type.value"
                >{{ type.label }}</el-radio-button
              >
            </el-radio-group>
          </el-form-item>
          <div v-if="discountForm.discount_item_type === 'specific_product'">
            <el-row :gutter="20" justify="center">
              <el-col :span="16">
                <el-row :gutter="20">
                  <el-col :span="16">
                    <el-form-item prop="menusByOutlet">
                      <el-select
                        v-model="discountForm.menusByOutlet"
                        filterable
                        clearable
                        multiple=""
                        placeholder="Бүтээгдэхүүн ..."
                        class="ml10"
                        value-key="pkey"
                        remote
                        reserve-keyword
                        :remote-method="searchProduct"
                      >
                        <el-option
                          v-for="product in allProducts"
                          :key="product.pkey"
                          :label="product.name_mon"
                          :value="product"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row
              :gutter="20"
              v-for="(product, index) in discountForm.menusByOutlet"
              :key="index"
            >
              <el-col :span="4" class="pt30 ml20">
                <strong>{{ product.name_mon }}</strong>
              </el-col>
              <el-col :span="6" class="pt20 ml20">
                <el-form-item required>
                  <el-input
                    placeholder="Доод хязгаар"
                    v-model="discountForm.menusByOutlet[index].min_count"
                  >
                    <template slot="append">Ш</template>
                  </el-input>
                  <span
                    style="color: red; font-size: 0.7vw"
                    v-if="discountForm.menusByOutlet[index].min_count === ''"
                    >Доод хязгаар заавал бичнэ!!!</span
                  >
                </el-form-item>
              </el-col>
              <el-col :span="6" class="pt20 ml20">
                <el-form-item required>
                  <el-input
                    placeholder="Дээд хязгаар"
                    v-model="discountForm.menusByOutlet[index].max_count"
                  >
                    <template slot="append">Ш</template>
                  </el-input>
                  <span
                    style="color: red; font-size: 0.7vw"
                    v-if="discountForm.menusByOutlet[index].max_count === ''"
                    >Дээд хязгаар заавал бичнэ!!!</span
                  >
                </el-form-item>
              </el-col>
              <el-col :xl="4" :lg="4" :md="4" :sm="4" :xs="4">
                <div class="text-right">
                  <i
                    class="el-icon-close cursor-pointer"
                    @click="removeSpecificProduct(product)"
                  ></i>
                </div>
              </el-col>
            </el-row>
          </div>
          <div v-else-if="discountForm.discount_item_type === 'service'">
            <el-form-item prop="selectedCategory">
              <el-select
                v-model="discountForm.selectedCategory"
                filterable
                clearable
                value-key="id"
                placeholder="Ангилал ..."
                remote
                reserve-keyword
                :remote-method="searchService"
              >
                <el-option
                  v-for="category in allServices"
                  :key="category.id"
                  :label="category.name_mon"
                  :value="category"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-row :gutter="20" v-if="discountForm.selectedCategory !== null">
              <el-col :span="4" class="pt30 ml20">
                <strong>{{ discountForm.selectedCategory.name_mon }}</strong>
              </el-col>
              <el-col :span="6" class="pt20 ml20">
                <el-input
                  placeholder="Доод хязгаар"
                  v-model="discountForm.min_count"
                >
                  <template slot="append">Ш</template>
                </el-input>
              </el-col>
              <el-col :span="6" class="pt20 ml20">
                <el-input
                  placeholder="Дээд хязгаар"
                  v-model="discountForm.max_count"
                >
                  <template slot="append">Ш</template>
                </el-input>
              </el-col>
            </el-row>
          </div>
          <div v-else-if="discountForm.discount_item_type === 'partners'">
            <el-form-item prop="selectedOutlet">
              <el-select
                v-model="discountForm.selectedOutlet"
                multiple
                filterable
                placeholder="Харилцагч ..."
                value-key="outlet_name"
                remote
                reserve-keyword
                :remote-method="searchPartners"
              >
                <el-option
                  v-for="outlet in outlets"
                  :key="outlet.outlet_id"
                  :label="outlet.outlet_name"
                  :value="outlet"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-row
              :gutter="20"
              v-for="(outlet, index) in this.discountForm.selectedOutlet"
              :key="index"
            >
              <el-col :span="4" class="pt30 ml20">
                <strong>{{ outlet.outlet_name }}</strong>
              </el-col>
              <el-col :span="6" class="pt20 ml20">
                <el-input
                  placeholder="Доод хязгаар"
                  v-model="discountForm.selectedOutlet[index].min_count"
                  :min="0"
                >
                  <template slot="append">Ш</template>
                </el-input>
                <span
                  style="color: red; font-size: 0.7vw"
                  v-if="discountForm.selectedOutlet[index].min_count === ''"
                  >Доод хязгаар заавал бичнэ!!!</span
                >
              </el-col>
              <el-col :span="6" class="pt20 ml20">
                <el-input
                  placeholder="Дээд хязгаар"
                  v-model="discountForm.selectedOutlet[index].max_count"
                  :min="0"
                >
                  <template slot="append">Ш</template>
                </el-input>
                <span
                  style="color: red; font-size: 0.7vw"
                  v-if="discountForm.selectedOutlet[index].max_count === ''"
                  >Дээд хязгаар заавал бичнэ!!!</span
                >
              </el-col>
              <el-col :xl="4" :lg="4" :md="4" :sm="4" :xs="4">
                <div class="text-right">
                  <i
                    class="el-icon-close cursor-pointer"
                    @click="removeOutlet(outlet)"
                  ></i>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    'discountForm',
    'discountItemTypesFood',
    'allProducts',
    'outlets',
    'allServices',
    'radioState',
    'searchService',
    'searchPartners',
    'searchProduct'
  ],
  methods: {
    removeOutlet (category) {
      this.discountForm.selectedOutlet =
        this.discountForm.selectedOutlet.filter(
          (el) => el.outlet_id !== category.outlet_id
        )
    },
    removeSpecificProduct (product) {
      this.discountForm.menusByOutlet = this.discountForm.menusByOutlet.filter(
        (el) => el.pkey !== product.pkey
      )
    }
  }
}
</script>
